<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/tradeLineList' }">交易行</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <draggableDetail :draggable="{ data_name: 'deal_line' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                (item.prop == 'product_name' && data['product_rid'] != '') ||
                                                (item.prop == 'order_name' && data['order_rid'] != '') ||
                                                (item.prop == 'order_line_rid' && data['order_line_rid'] != '') ||
                                                (item.prop == 'deal_line_rid' && data['deal_line_rid'] != '') ||
                                                (item.prop == 'order_detail_rid' && data['order_detail_rid'] != '')
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="交易明细" name="2">
                    <vDealDetailListComponent v-if="flag" :postList="commonParams"></vDealDetailListComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vDealDetailListComponent from '../../listComponent/order/dealDetailListComponent.vue';
import { processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'tradeLineDetails',
    components: {
        vDealDetailListComponent,
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '交易行详情',
            commonParams: {},
            flag: false // 所有的明细列表公用一个flag
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.initListsParams();
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.initListsParams();
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        initListsParams() {
            this.commonParams.params = {
                deal_line_rid: this.queryParams.rid
            };
        },
        toDetail(prop) {
            if (prop == 'product_name') {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.product_rid
                    }
                });
            } else if (prop == 'order_name') {
                this.$router.push({
                    path: '/orderDetail',
                    query: {
                        id: this.data.order_rid
                    }
                });
            } else if (prop == 'order_line_rid') {
                this.$router.push({
                    path: '/orderLineDetail',
                    query: {
                        id: this.data.order_line_rid
                    }
                });
            } else if (prop == 'order_detail_rid') {
                this.$router.push({
                    path: '/orderParticulars',
                    query: {
                        id: this.data.order_detail_rid
                    }
                });
            } else if (prop == 'deal_line_rid') {
                this.$router.push({
                    path: '/tradeLineDetails',
                    query: {
                        id: this.data.deal_line_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).deal_line;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .dealLineDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>